
const ImageApi = "https://bs.aalantechsoft.com:8008"

export default ImageApi